export var TransferDirection;
(function (TransferDirection) {
    TransferDirection["left"] = "left";
    TransferDirection["right"] = "right";
})(TransferDirection || (TransferDirection = {}));
